// extracted by mini-css-extract-plugin
module.exports = {"social-share__wrapper":"SocialShare_social-share__wrapper__26iTG","social-share__wrapper2":"SocialShare_social-share__wrapper2__2yZcK"};